/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import {Route, Redirect} from "react-router-dom";
import {isAuthenticated} from "../lib/utils/auth.utils";

const Public = ({
  component: Component,
  layout: Layout,
  ...rest
}: {
  component: any;
  layout: any;
  exact?: boolean;
  path: string;
}) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        if (isAuthenticated()) {
          return (
            <Redirect
              to={{
                pathname: "/",
                state: {from: props.location},
              }}
            />
          );
        }
        return (
          <Layout>
            <Component {...props} />
          </Layout>
        );
      }}
    />
  );
};

export default Public;
